import _ from "lodash";
import moment from "moment";
import api from "@/service/memberManage.js";

const state = {};
const getters = {}
const actions = {
  memberLevelSave({
    state,
    commit
  }, data) {
    let result = api.memberLevelSave(data);
    result.then((data) => {
      console.log(data.data);
    });
    return result;
  }
};
const mutations = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
